export default [
  {
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/app/',
    icon: 'fas fa-home',
    title: 'Dashboard',
    menu: true,
    meta: {
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/contabilidade',
    title: 'Contabilidade',
    dir: 'views/app/Contabilidade/',
    icon: 'fa-solid fa-dollar-sign',
    menu: true,
    meta: {
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: false
    },
    items: [
      {
        path: '/Consultas',
        title: 'Consultas',
        dir: 'Consultas/',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/movimento-contabil',
            title: 'Movimento Contábil',
            dir: 'MovimentoContabil/',
            view: 'MovimentoContabil',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/movimento-contabil-sem-geracao',
            title: 'Movimento Contábil Sem Geração',
            dir: 'MovimentoContabilSemGeracao/',
            view: 'MovContabilSemGeracao',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/eventos-contabeis-cadastrados',
            title: 'Eventos Contábeis Cadastrados',
            dir: 'EventoContabil/',
            view: 'EventoContabilCadastrado',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/proposta-paga',
            title: 'Propostas Pagas',
            dir: 'PropostaPaga/',
            view: 'PropostaPaga',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/proposta-paga-cedida',
            title: 'Propostas Pagas e Cedidas',
            dir: 'PropostaPagaECedida/',
            view: 'PropostaPagaECedida',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/proposta-cancelada',
            title: 'Propostas Canceladas',
            dir: 'PropostaCancelada/',
            view: 'PropostaCancelada',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/proposta-pendente-pagamento',
            title: 'Propostas Pendente Pagamento',
            dir: 'PropostaPendentePagamento/',
            view: 'PropostaPendentePagamento',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/historico-operacao',
            title: 'Histórico Operações',
            dir: 'HistoricoOperacao/',
            view: 'HistoricoOperacao',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/transferencia-prejuizo',
            title: 'Transferência Prejuízo',
            dir: 'TransferenciaPrejuizo/',
            view: 'TransferenciaPrejuizo',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/iof',
            title: 'IOF',
            dir: 'IOF/',
            view: 'IOF',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/pdd',
            title: 'PDD',
            dir: 'PDD/',
            view: 'PDD',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/saldo-parcela',
            title: 'Saldo Parcela',
            dir: 'SaldoParcela/',
            view: 'SaldoParcela',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/relatorios-saldo-contrato',
            title: 'Saldo Contrato',
            dir: 'RelatoriosSaldoContrato/',
            view: 'RelatoriosSaldoContrato',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: '/Cadastros',
        title: 'Cadastros',
        dir: 'Cadastros/',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/evento-contabil',
            title: 'Evento Contábil',
            dir: 'EventoContabil/',
            view: 'Contabil',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/evento-contabil-geral',
            title: 'Evento Contábil Geral',
            dir: 'EventoContabilGeral/',
            view: 'EventoContabilGeral',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/evento-contabil-recebimento',
            title: 'Evento Contábil Recebimento',
            dir: 'EventoContabilRecebimento/',
            view: 'EventoContabilRecebimento',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/rede-loja-nao-contabilizar',
            title: 'Não Contabilizar Rede',
            dir: 'RedeLojaNaoContabilizar/',
            view: 'RedeLojaNaoContabilizar',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/controle-nivel-risco',
            title: 'Controle Nível Risco',
            dir: 'ControleNivelRisco/',
            view: 'ControleNivelRisco',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/tipo-contrato-detalhe',
            title: 'Tipo Contrato Detalhe',
            dir: 'TipoContratoDetalhe/',
            view: 'TipoContratoDetalhe',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/contratos-renegociacao',
            title: 'Contratos Renegociação',
            dir: 'ContratosRenegociacao/',
            view: 'ContratosRenegociacao',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: '/Ajustes',
        title: 'Ajustes',
        dir: 'Ajustes/',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/movimentos-pendentes',
            title: 'Movimentos Pendentes',
            dir: 'MovimentoPendente/',
            view: 'MovimentoPendente',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/movimentos-contabeis',
            title: 'Movimentos Contábeis',
            dir: 'MovimentosContabeis/',
            view: 'MovimentosContabeis',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      }
    ]
  },
  {
    path: '/comissionamento',
    title: 'Comissionamento',
    dir: 'views/app/Comissionamento/',
    icon: 'fas fa-percentage',
    menu: true,
    meta: {
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: false
    },
    items: [
      {
        path: '/parametrizacao',
        title: 'Parametrização',
        dir: 'Parametrizacao/',
        view: 'Parametrizacao',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        }
      },
      {
        path: '/cadastro',
        title: 'Cadastros',
        dir: 'Cadastros/',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/conta-cr',
            title: 'Conta CR',
            dir: 'ContaCR/',
            view: 'ContaCR',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/lista-servico-comissionamento',
            title: 'Serviços',
            dir: 'ComissionamentoListaServico/',
            view: 'ComissionamentoListaServico',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/grupo-comissionamento',
            title: 'Grupos',
            dir: 'ComissionamentoGrupo/',
            view: 'ComissionamentoGrupo',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: '/relatorio',
        title: 'Relatório',
        dir: 'Relatorio/',
        view: 'Relatorio',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        }
      }
    ]
  },
  {
    path: '/regulatorio',
    title: 'Regulatório',
    dir: 'views/app/Regulatorio/',
    icon: 'fas fa-certificate',
    menu: true,
    meta: {
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: false
    },
    items: [
      {
        path: '/cadoc3040',
        title: 'CADOC 3040',
        dir: 'Cadoc3040/',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/parametros',
            title: 'Parâmetros',
            dir: 'Parametros/',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            },
            items: [
              {
                path: '/parametro-cadoc',
                title: 'Parâmetros Cadoc 3040',
                dir: 'ParametrosCadoc/',
                view: 'ParametroCadoc',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/tipo-identidade-exterior',
                title: 'Tipo Identidade Exterior',
                dir: 'TipoIdentidadeExterior/',
                view: 'TipoIdentidadeExterior',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/faixa-valores',
                title: 'Faixa de Valores',
                dir: 'FaixaValores/',
                view: 'FaixaValores',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/natureza-operacao',
                title: 'Natureza Operação',
                dir: 'NaturezaOperacao/',
                view: 'NaturezaOperacao',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/origem-recurso',
                title: 'Origem Recurso',
                dir: 'OrigemRecurso/',
                view: 'OrigemRecurso',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/porte-pessoa-pf',
                title: 'Porte Pessoa PF',
                dir: 'PortePessoaPF/',
                view: 'PortePessoaPF',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/porte-pessoa-pj',
                title: 'Porte Pessoa PJ',
                dir: 'PortePessoaPJ/',
                view: 'PortePessoaPJ',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/tipo-controle',
                title: 'Tipo Controle',
                dir: 'TipoControle/',
                view: 'TipoControle',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/indexador',
                title: 'Indexador',
                dir: 'Indexador/',
                view: 'Indexador',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/tipo-uso-regulatorio',
                title: 'Tipo Uso Regulatório',
                dir: 'TipoUsoRegulatorio/',
                view: 'TipoUsoRegulatorio',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/caracteristica-especial',
                title: 'Característica Especial',
                dir: 'CaracteristicaEspecial/',
                view: 'CaracteristicaEspecial',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/garantia',
                title: 'Garantia',
                dir: 'Garantia/',
                view: 'Garantia',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              },
              {
                path: '/tipo-instrumento',
                title: 'Tipo Instrumento',
                dir: 'TipoInstrumento/',
                view: 'TipoInstrumento',
                menu: true,
                meta: {
                  roles: ['Safe.BackOffice.User'],
                  allRolesRequired: false
                }
              }
            ]
          },
          {
            path: '/remessa',
            title: 'Remessa',
            view: 'Remessa',
            dir: 'Remessa/',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/restricao-cadoc',
            title: 'Restrição CADOC',
            dir: 'RestricaoCADOC/',
            menu: true,
            view: 'RestricaoCADOC',
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: '/cadoc3044',
        title: 'CADOC 3044',
        dir: 'Cadoc3044/',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/remessa3044',
            title: 'Remessa',
            dir: 'Remessa3044/',
            view: 'Remessa3044',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/propostas-sem-modalidade',
            title: 'Sem Modalidade',
            dir: 'PropostaSemModalidade3044/',
            view: 'PropostaSemModalidade3044',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: '/cadoc4111',
        title: 'CADOC 4111',
        dir: 'Cadoc4111/',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/cadastro',
            title: 'Cadastro',
            dir: 'Cadastro/',
            view: 'Cadastro4111',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/remessa4111',
            title: 'Remessa',
            dir: 'Remessa4111/',
            view: 'Remessa4111',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: '/ParametrosGerais',
        title: 'Parâmetros Gerais',
        dir: 'ParametrosGerais/',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/modalidade-operacao',
            title: 'Modalidade Operação',
            dir: 'ModalidadeOperacao/',
            view: 'ModalidadeOperacao',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/grupo-produto-bacen',
            title: 'Grupo Produto BACEN',
            dir: 'GrupoProdutoBACEN/',
            view: 'GrupoProdutoBACEN',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/responsabilidade',
            title: 'Responsabilidade',
            dir: 'Responsabilidade/',
            view: 'Responsabilidade',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      }
    ]
  },
  {
    path: '/sistema',
    title: 'Sistema',
    dir: 'views/app/Sistema/',
    icon: 'fa-solid fa-cog',
    menu: true,
    meta: {
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: false
    },
    items: [
      {
        path: '/operador',
        title: 'Operador',
        dir: 'Operador/',
        view: 'Operador',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.Admin'],
          allRolesRequired: false
        }
      },
      {
        path: '/feriado-extra',
        title: 'Feriados Extras',
        dir: 'FeriadoExtra/',
        view: 'FeriadoExtra',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        }
      },
      {
        path: '/controle-operacoes',
        title: 'Controle Operações',
        dir: 'ControleOperacoes/',
        view: 'ControleOperacoes',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.Admin'],
          allRolesRequired: false
        }
      },
      {
        path: '/alertas',
        dir: 'Alertas/',
        title: 'Alertas',
        menu: true,
        meta: {
          roles: ['Safe.BackOffice.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/envio-email',
            title: 'Envio de E-mail',
            dir: 'EnvioEmail/',
            view: 'EnvioEmail',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/excecoes-comissionamento',
            dir: 'Excecao/',
            title: 'Exceções Comissionamento',
            view: 'ExcecaoComissionamento',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/fechamento-mensal-comissionamento',
            dir: 'FechamentoMensalComissionamento/',
            title: 'Fechamento Mensal',
            view: 'FechamentoMensalComissionamento',
            menu: true,
            meta: {
              roles: ['Safe.BackOffice.User'],
              allRolesRequired: false
            }
          }
        ]
      }
    ]
  },
  {
    path: '/empresa',
    view: 'Empresa',
    dir: 'views/',
    title: 'Empresa',
    menu: false,
    meta: {
      anonymousAuth: true,
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: true
    }
  },
  {
    path: '/',
    view: 'Login',
    dir: 'views/',
    title: 'Login',
    menu: false,
    meta: {
      anonymousAuth: true,
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: true
    }
  },
  {
    path: '/senha/lembrar',
    view: 'Lembrar',
    dir: 'views/',
    title: 'Lembrar',
    menu: false,
    meta: {
      anonymousAuth: true,
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: true
    }
  },
  {
    path: '/senha/recuperar',
    view: 'Recuperar',
    dir: 'views/',
    title: 'Recuperar',
    params: true,
    menu: false,
    meta: {
      anonymousAuth: true,
      roles: ['Safe.BackOffice.User'],
      allRolesRequired: true
    }
  }
];
